import { UPDATE_HAS_FEATURE_DOC, UPDATE_STATUS, CLEAR_DATA } from "./actionTypes";

const INIT_STATE = {
  depotStatus: "Closed",
  hasFeatureDOC: false,
};

const Utils = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_STATUS:
      return {
        ...state,
        depotStatus: action.payload,
      };
    case UPDATE_HAS_FEATURE_DOC:
      return {
        ...state,
        hasFeatureDOC: action.payload,
      };
    case CLEAR_DATA:
      return INIT_STATE;
    default:
      return state;
  }
};

export default Utils;
